import { Pressable, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import LocationInfo from "../molecules/LocationInfo";
import { EditIcon, Icon } from "ui/gluestack/icon";
import { useMemo, useState } from "react";
import { EditFloorPlanModal } from "../modals/EditFloorPlanModal";
import { useLocation } from "../provider/LocationProvider";
import { useLocalSearchParams } from "expo-router";

export function LocationHeaderTemplate() {
  const { location, isLoading, locationId } = useLocation();

  const details = useMemo(() => {
    if (!location) return [];
    return [
      `${location.floors_count} floors`,
      `${location.rooms_count} rooms`,
      `${location.user_count} users`,
      `${location.residents_count} residents`,
    ];
  }, [location]);

  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible((prevState) => !prevState);
  };

  return (
    <View className="pl-4 flex-1 w-full">
      {isLoading ? (
        <View className="flex-1 justify-center items-center my-10">
          <LoadingSpinner />
        </View>
      ) : (
        <View>
          <Text className="text-xl text-primary-500 font-semibold">
            {location?.name}
          </Text>
          <View className="flex flex-row justify-between mt-3">
            <LocationInfo details={details} />
            <Pressable
              onPress={toggleModal}
              className="flex-row items-center gap-x-2 group"
            >
              <Text className="group-hover:text-primary-400">
                Edit Floor Plan
              </Text>
              <Icon
                as={EditIcon}
                className="w-4 h-4 group-hover:stroke-primary-400"
              />
            </Pressable>
          </View>
          <EditFloorPlanModal
            isVisible={isModalVisible}
            onClose={() => {
              setModalVisible(!isModalVisible);
            }}
            locationId={locationId}
            locationName={location?.name}
          />
        </View>
      )}
    </View>
  );
}
